// Import SASS
import '../sass/style.scss'

// Node_modules
import objectFitImages from 'object-fit-images'

// Import scripts
import './modules/skip-link-focus-fix'
import initYoutubeVideos from './modules/init-after-youtube-api' // when videos are loaded on the page

import '../partials/navigation/menus/menus'
// import '../partials/search/search'
import initSliders from '../partials/sliders/sliders'
import { initBlockSlider } from '../partials/blocks/block/block-slider'

window.onYouTubeIframeAPIReady = function() {
	initYoutubeVideos();
}

// Object-fit fix
objectFitImages()

// Init slider
let sliders = initSliders();
console.log(sliders);

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

import baguetteBox from 'baguettebox.js';

if (document.querySelector('.slideshow')) {
 baguetteBox.run('.slideshow');
};